import React from 'react';
import {assetsBaseUrl} from "../../services/calculationsApi";
import {FormattedMessage} from "react-intl";


const LoadingModal = () => {
    return (
        <div className="ct-step__modal-wrapper">
            <div className="ct-step__loading-modal">
                <div className="ct-step__loading-modal-title">
                    <FormattedMessage id={'loadingModal.title'} defaultMessage={'We zijn nu je beste deal aan het opzoeken'}/>
                </div>

                <div className="ct-step__loading-modal-text">
                    <img src={`${assetsBaseUrl}/assets/svg/check.svg`} alt=""/>
                    <FormattedMessage id={'loadingModal.text'} defaultMessage={'Wij vergelijken meer dan 40 banken en zoeken de beste deal'}/>
                </div>

                <img src={`${assetsBaseUrl}/assets/svg/loader-dots.svg`} alt=""/>
            </div>
        </div>
    );
};

export default LoadingModal;
